import styled from 'styled-components';
import { CALLER_COLORS as C } from '../tokens';

type Props = {
  onBack: () => void;
  onSms?: () => void;
  onBook?: () => void;
  bookDisabled?: boolean;
  bookLabel?: string; // names the customer being booked, e.g. "Book · Lisa"
};

// Sticky footer — Back / SMS / Book.
const DetailFooter = ({ onBack, onSms, onBook, bookDisabled, bookLabel = 'Book' }: Props) => (
  <FooterBar>
    <BackBtn type="button" onClick={onBack}>
      Back
    </BackBtn>
    <SmsBtn type="button" onClick={onSms}>
      SMS
    </SmsBtn>
    <BookBtn type="button" onClick={onBook} disabled={bookDisabled} title={bookLabel}>
      {bookLabel}
    </BookBtn>
  </FooterBar>
);

export default DetailFooter;

const FooterBar = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  padding: 15px 16px 14px;
  background: #fff;
  border-top: 1px solid ${C.border};
`;
const FooterButton = styled.button`
  flex: 1 0 0;
  min-width: 0;
  height: 54px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  &:active {
    opacity: 0.7;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
const BackBtn = styled(FooterButton)`
  background: #fff;
  border: 1px solid ${C.border};
  color: ${C.navy};
`;
const SmsBtn = styled(FooterButton)`
  background: #fff;
  border: 1px solid ${C.border};
  color: ${C.navy};
`;
const BookBtn = styled(FooterButton)`
  padding: 0 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: ${C.greenBtn};
  border: 1px solid ${C.greenBtnBorder};
  color: #fff;
`;
